export const title = "Laporan Jatuh Tempo Service Dutro By KM";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Kendaraan",
  field: "nomor_polisi",
  // data_field: "data_kendaraan",
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "SERVICE",
    field: "service_nama",
    type: "string",
    width: "w-[15rem]",
    layout: "col-start-start",
  },
  {
    name: "KM TERAKHIR",
    field: "speedo_akhir",
    type: "number",
    width: "w-[7.5rem]",
    layout: "col-start-end",
  },
  {
    name: "KM NEXT",
    field: "next",
    type: "number",
    width: "w-[7rem]",
    layout: "col-start-end",
  },
  {
    name: "KM SELISIH",
    field: "selisih",
    type: "number",
    width: "w-[7rem]",
    layout: "col-start-end",
  },
  {
    name: "SERVICE TERAKHIR",
    field: "tanggal_terakhir_service",
    type: "date",
    format: "dd/MM/yyyy",
    layout: "col-start-start",
    width: "w-[13.5rem]",
  },
];
